import React from "react";
import { HashLoader } from "react-spinners";

export default function Loading() {
  return (
    <div
      style={{
        position: "fixed", 
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(248, 249, 250, 0.7)",
        zIndex: 9999          
      }}
    >
      <HashLoader loading={true} color="#FFDD00" size={150} />
    </div>
  );
}